import builder from '../builder';
import SendEmail from '../../streamline-icons/light/send-email.svg';

export default builder('IconSendEmailLight', SendEmail);
